import { Component, Host, h, Prop } from '@stencil/core';
/**
 * @slot - Designed to receive the text you want to display.
 */
export class Text {
  constructor() {
    this.tagType = {
      h1: 'h1',
      h2: 'h2',
      h3: 'h3',
      h4: 'h4',
      h5: 'h5',
      h6: 'h6',
      body: 'span',
      small: 'small',
      code: 'pre',
      lead: 'p',
    };
    /**
     * Sets the text type.
     */
    this.type = 'body';
  }
  render() {
    const TextTag = this.tagType[this.type] || 'span';
    return (h(Host, null,
      h(TextTag, { class: "sy-text" },
        h("slot", null))));
  }
  static get is() { return "sy-text"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() { return {
    "$": ["scss/index.scss", "scss/_tokens.scss"]
  }; }
  static get styleUrls() { return {
    "$": ["./scss/index.css", "./scss/_tokens.css"]
  }; }
  static get properties() { return {
    "type": {
      "type": "string",
      "mutable": false,
      "complexType": {
        "original": "'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'body' | 'small' | 'code' | 'lead'",
        "resolved": "\"body\" | \"code\" | \"h1\" | \"h2\" | \"h3\" | \"h4\" | \"h5\" | \"h6\" | \"lead\" | \"small\"",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "Sets the text type."
      },
      "attribute": "type",
      "reflect": true,
      "defaultValue": "'body'"
    }
  }; }
}
